const InterfaceQuestionFromApi = {
  id: 0,
  type_question: '',
  type_question_text: '',
  question: '',
  option_answers: [],
  min_value: 0,
  max_value: 0,
  min_label: '',
  max_label: '',
  required: false,
};

const TYPE_QUESTIONS = {
  '1': 'multipleChoice',
  '2': 'singleChoice',
  '3': 'range',
  '4': 'openAnswer',
  '5': 'fillTable',
  '6': 'fillTime',
};

class InputDynamicBuilder {
  _question = [];
  _option = '';

  constructor(externalQuestion = InterfaceQuestionFromApi, answers, index) {
    this._question = this.translateExternalQuestionToQuestion(externalQuestion, answers, index);
    this._option = TYPE_QUESTIONS[externalQuestion.type_question];
  }

  translateExternalQuestionToQuestion(question = InterfaceQuestionFromApi, answers = [], index) {
    return {
      options: question.option_answers,
      question: question.question,
      id: question.id,
      index: index,
      min_value: question.min_value,
      max_value: question.max_value,
      min_label: question.min_label,
      max_label: question.max_label,
      required: false,
      answers: answers,
    };
  }

  getDynamicComponent() {
    const component = this._option;
    return {
      component: () => import(`@/components/planning/question/${component}.vue`),
      props: this._question,
      id: this._question.id,
    };
  }
}

export default InputDynamicBuilder;
